import { DatePipe } from '@angular/common';
import { Component, signal, inject, computed } from '@angular/core';
import { RouterModule } from '@angular/router';
import { toSignal } from '@angular/core/rxjs-interop';
import { FormsModule } from '@angular/forms';
import { UiModule } from '@components/ui/ui-module';
import { RemoteSet } from '@models/card.model';
import { Scrap as ScrapService } from '@services/scrap.service';
import { Router } from '@services/route.service';
import { filter, map, Observable, skip, take, tap } from 'rxjs';

@Component({
  selector: 'lgb-scrap',
  imports: [
    UiModule,
    DatePipe,
    FormsModule,
    RouterModule
  ],
  templateUrl: './scrap.html',
  styleUrl: './scrap.css',
})
export class Scrap {
  readonly sets=signal<RemoteSet[]>([]);
  readonly qSearch=signal<string>(null);

  //service
  readonly scrapS=inject(ScrapService);
  readonly router=inject(Router);

  //UI
  readonly loading=signal<boolean>(false);

  getSearchObs(){
    return (q: string, start: number, length: number) => {
      let obs: Observable<RemoteSet[]>=this.scrapS.getRemoteSetList();

      //filter
      if(q!=null && q.trim()!=""){
        obs=obs.pipe(
          map(sets => sets.filter(s => s.name.toLowerCase().indexOf(q)!=-1))
        );
      }

      obs=obs.pipe(
        map(sets => sets.slice().reverse().slice(start, start+length))
      );

      return obs;
    }
  }
}
